export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";